<template>
  <div :class="['rb-unselected-warn', { 'rb-active': showNotice }]">
    Please make a selection to move to the next step
  </div>
</template>
<script>
/**
 * Small widget that displays a message when it does not detect user activity
 *
 * @implements
 * CommMixin
 *
 * @listens
 * rb-step-display-update
 * rb-selected-options-updated
 */
import CommMixin from "@/mixins/CommMixin";
export default {
  mixins: [CommMixin],
  data: function () {
    return {
      to: null,
      showNotice: false,
      optionsUpdated: true,
    };
  },
  mounted: function () {
    this.subscribe("rb-step-display-update", this.onStepDisplayUpdate);
    this.subscribe(
      "rb-selected-options-updated",
      this.onSelectedOptionsUpdated
    );
  },
  methods: {
    startCounter: function () {
      console.log("starting counter");
      this.to = setTimeout(() => {
        if (!this.optionsUpdated) {
          console.log("aadadad");
          this.showNotice = true;
        }
      }, 10000);
    },
    clearCounter: function () {
      this.optionsUpdated = false;
      this.showNotice = false;
      clearTimeout(this.to);
    },
    onStepDisplayUpdate: function (step) {
      this.clearCounter();
      if (
        step.id === "summary" ||
        step.id === "diamond" ||
        step.id === "engraving"
      )
        return;
      this.startCounter();
    },
    onSelectedOptionsUpdated: function () {
      this.optionsUpdated = true;
      this.showNotice = false;
    },
  },
};
</script>
